import { mapActionsFromConfigurations } from '../../helpers/action';
import { attemptConfigurations, questionAttemptConfigurations, questionConfigurations } from './configurations';
import { apiAction as addAttempt } from './configurations/attempts/add';
import { apiAction as getAttempts } from './configurations/attempts/get';
import { apiAction as updateAttempt } from './configurations/attempts/update';
import { apiAction as submitAnswer } from './configurations/questionAttempts/submitAnswer';
import { apiAction as getQuestions } from './configurations/questions/get';

const actions = {
  quiz: {
    ...mapActionsFromConfigurations('questions')(questionConfigurations),
    ...mapActionsFromConfigurations('attempts')(attemptConfigurations),
    ...mapActionsFromConfigurations('questionAttempts')(questionAttemptConfigurations)
  }
};

export const apiActions = {
  quiz: {
    questions: {
      get: getQuestions
    },
    attempts: {
      get: getAttempts,
      add: addAttempt,
      update: updateAttempt,
    },
    questionAttempts: {
      submitAnswer
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/quiz/actions.js